export default __webpack_public_path__ + "static/media/date-icon.6980e6fc.svg";